import { GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';

async function trackBuyVoucherOrShowClusterClicked(label: string): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'ButtonClick',
        label: 'BuyVoucher',
        eventData: {
            eventName: GA4EventName.SelectVoucherType,
            feature_category: GA4FeatureCategory.ProductDetailClusterProductList,
            selected_value: label,
        },
    });
}

export { trackBuyVoucherOrShowClusterClicked };
